<template>
	<div class="order-body">
		<ul class="order-menu">
			<li
				v-for="item in orderMenu"
				:key="item.name"
				v-show="item.authorityShow"
				:class="{ active : active === item.name }"
				@click="orderMenuSwitch(item)"
			>
				{{item.name}}<span v-show="item.countFlag && +item.count <= 99">{{item.count}}</span>
				<span v-show="item.countFlag && +item.count > 99" class="big-num">99+</span>
			</li>
			<div v-if="active !== '全部订单' && active !== '已完成' && active !== '已取消' ">
				<span v-if="totalOrderCount !== 0">当前有<span style="color: #f85050;margin:0 5px;">{{totalOrderCount}}</span>张尚未处理的【{{active}}】订单</span>
				<span v-else>当前没有需要处理的订单</span>
			</div>
		</ul>
		<Search :ids="ids" :needauditingflag='needauditingflag' :customList="customList" :lineList="lineList" :active="active" :clddock="clddock" :clearing="clearing" :origin="origin" ref='searchRef' @openPrinter="openPrinter" @liquidate="liquidate" @handleSearch="handleSearch" @exportExcel="exportExcel"/>
		<MainTable
			:clddock="clddock"
			:backorderdock="backorderdock"
			:active="active"
			:size='size'
			:page='page'
			:orderSort='orderSort'
			:tableData='tableData'
			:totalCount='totalCount'
			:needauditingflag='needauditingflag'
			:canundeliveredunpaysendflag='canundeliveredunpaysendflag'
			@saveSelect='saveSelect'
			@modifySuc="modifySuc"
			@sortList='sortList'
			@handleSize='handleSizeChange'
			@handlePage='handlePageChange'
			@selectIds="selectIdsChange"
		/>
		<el-dialog
			title="打印设置"
			:visible.sync="printerVisible"
			class="dialog-title"
			width="530px">
				<Print :ids="ids" :templateType="0" v-if="printerVisible"/>
		</el-dialog>
	</div>
</template>

<script>
import Print from '@/components/print/Print.vue'
import Search from '@/views/index/src/orderDock/Search.vue'
import MainTable from '@/views/index/src/orderDock/MainTable.vue'
export default {
	name: 'order',
	components: {
		Search,
		MainTable,
		Print
	},
	data () {
		return {
			shopOptions: [],
			sellerShopId: '',
			orderMenu: [
				{ name: '全部订单', orderStatus: 8, countFlag: false, isSellerpull: false, authorityShow: true },
				{ name: '待付款', orderStatus: 0, billState: 0, count: 0, countFlag: true, isSellerpull: false, authorityShow: false },
				{ name: '待接单', orderStatus: 1, billState: 1, count: 0, countFlag: true, isSellerpull: false, authorityShow: false },
				{ name: '财务审核', orderStatus: 6, billState: 6, count: 0, countFlag: true, isSellerpull: false, authorityShow: false },
				{ name: '待发货', orderStatus: 2, billState: 2, count: 0, countFlag: true, isSellerpull: false, authorityShow: false },
				{ name: '备货中', orderStatus: 2, billState: 4, count: 0, countFlag: true, isSellerpull: true, authorityShow: false },
				{ name: '待收货', orderStatus: 3, billState: 3, count: 0, countFlag: true, isSellerpull: false, authorityShow: false },
				{ name: '已完成', orderStatus: 4, countFlag: false, isSellerpull: false, authorityShow: false },
				{ name: '已取消', orderStatus: 5, countFlag: false, isSellerpull: false, authorityShow: false }
			],
			active: '全部订单',
			dateValue: [],
			buyerTel: '',
			orderNumber: '',
			keyword: '',
			paymentMode: '-1',
			acceptMode: '-1',
			cancelMode: '-1',
			ordersource: '-1',
			pushstate: '-1',
			liquidateflag: '-1',
			buyerName: '',
			orderStatus: 8,
			isSellerpull: false,
			page: 1,
			size: 20,
			tableData: [],
			totalCount: 0,
			isCancel: false,
			tabParams: {},
			clearing: '0',
			totalOrderCount: 0,
			clddock: 0,
			backorderdock: 0,
			origin: '',
			excelParams: {},
			ids: [],
			printerVisible: false,
			dateType: 0,
			needauditingflag: false,
			canundeliveredunpaysendflag: false,
			customList: [],
			lineList: [],
			customerCategoryId: '0',
			lineId: '0',
			address: '',
			productName: '',
			customerName: '',
			orderSort: '',
			financialOrderCount: 0,
			needFinancialAuditingFlag: false
		}
	},
	created () {
		this.login().then(res => {
			this.getCategory()
			this.getLine()
			this.getSystemSet().then((data) => {
				if (this.needauditingflag) {
					[this.orderMenu[1], this.orderMenu[2]] = [this.orderMenu[2], this.orderMenu[1]]
				}
				this.getAuthority('07_0001_0000_00')
				this.openPage()
			})
		})
	},
	methods: {
		login () {
			return new Promise((resolve, reject) => {
				if (!this.$route.query.password) {
					resolve()
					return false
				}
				window.sessionStorage.setItem('password', this.$route.query.password)
				window.sessionStorage.setItem('username', this.$route.query.username)
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIV}/match/returnShiroSession`
				}).then(res => {
					if (res.result) {
						window.sessionStorage.setItem('shiroSession', res.data.shiroSession)
						resolve()
					} else {
						this.$message.error(res.msg)
					}
				}).catch(err => {
					this.$message.error(err.msg)
				})
			})
		},

		liquidate (type) {
			let arr = []
			this.tableData.forEach(e => {
				if (e.checked) {
					arr.push(e.orderid)
				}
			})
			let text = type === 0 ? '取消' : ''
			if (arr.length === 0) {
				this.$message.error('请勾选需要' + text + '勾销的数据')
				return false
			}
			let params = {
				liquidateflag: type,
				orderids: arr.join(',')
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/liquidateflag`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('当前选择' + arr.length + '条数据全部' + text + '勾销')
					this.findOrderList()
				} else {
					this.$message.error('勾销失败，请稍后重试')
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		openPrinter () {
			console.log(this.ids)
			this.printerVisible = true
		},
		selectIdsChange (ids) {
			this.ids = ids
		},
		saveSelect () {
			let params = {
				dateValue: this.dateValue,
				buyerTel: this.buyerTel,
				orderNumber: this.orderNumber,
				keyword: this.keyword,
				paymentMode: this.paymentMode,
				buyerName: this.buyerName,
				acceptMode: this.acceptMode,
				ordersource: this.ordersource,
				cancelMode: this.cancelMode,
				pushstate: this.pushstate,
				liquidateflag: this.liquidateflag,
				dateType: this.dateType,
				customerCategoryId: this.customerCategoryId,
				lineId: this.lineId,
				address: this.address,
				productName: this.productName,
				customerName: this.customerName,
				page: this.page,
				size: this.size
			}
			window.sessionStorage.setItem('orderSelect', JSON.stringify(params))
		},
		getAuthority (data) {
			let params = {
				pId: data
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						switch (a[i]) {
						case '07_0001_0001_00':
							this.orderMenu[1].authorityShow = true
							break
						case '07_0001_0004_00':
							this.orderMenu[2].authorityShow = true
							break
						case '07_0001_0007_00':
							this.orderMenu[3].authorityShow = true
							break
						case '07_0001_0010_00':
							this.orderMenu[4].authorityShow = true
							break
						case '07_0001_0013_00':
							this.orderMenu[5].authorityShow = true
							break
						case '07_0001_0016_00':
							this.orderMenu[6].authorityShow = true
							break
						case '07_0001_0019_00':
							this.orderMenu[7].authorityShow = true
							break
						}
					}
				}
			})
		},
		// 客户类别
		getCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customerCategory/list`
			}).then(res => {
				if (res.result === true) {
					this.customList = res.data.childNode
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		// 线路
		getLine () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/line/listfilter`
			}).then(res => {
				this.lineList = res
			})
		},
		openPage () {
			let tabParams = ''
			if (window.sessionStorage.getItem('tabInfo')) {
				tabParams = window.sessionStorage.getItem('tabInfo')
				if (JSON.parse(tabParams).active === '已取消') {
					this.isCancel = true
				} else {
					this.isCancel = false
				}
				if (!JSON.parse(tabParams).origin) {
					this.dateValue = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59']
				} else {
					this.origin = JSON.parse(tabParams).origin
				}
				this.orderStatus = JSON.parse(tabParams).orderStatus
				this.isSellerpull = JSON.parse(tabParams).isSellerpull
				this.sellerShopId = JSON.parse(tabParams).sellerShopId
				this.orderMenu.forEach(item => {
					if (this.orderStatus === item.orderStatus) {
						this.active = item.name
					}
					if (this.orderStatus === 2) {
						this.active = this.isSellerpull ? '备货中' : '待发货'
					}
				})
			} else {
				this.dateValue = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59']
				this.tabParams.active = this.active
				this.tabParams.isSellerpull = false
				this.tabParams.orderStatus = 8
			}
			if (window.sessionStorage.getItem('orderSelect')) {
				let data = JSON.parse(window.sessionStorage.getItem('orderSelect'))
				this.dateValue = data.dateValue
				this.buyerTel = data.buyerTel
				this.orderNumber = data.orderNumber
				this.keyword = data.keyword
				this.paymentMode = data.paymentMode
				this.buyerName = data.buyerName
				this.acceptMode = data.acceptMode
				this.ordersource = data.ordersource
				this.cancelMode = data.cancelMode
				this.pushstate = data.pushstate
				this.liquidateflag = data.liquidateflag
				this.dateType = data.dateType
				this.customerCategoryId = data.customerCategoryId
				this.lineId = data.lineId
				this.address = data.address
				this.productName = data.productName
				this.customerName = data.customerName
				this.page = data.page
				this.size = data.size
				this.excelParams = {
					beginDate: window.sessionStorage.getItem('orderSearchTime') ? JSON.parse(window.sessionStorage.getItem('orderSearchTime'))[0] : data.dateValue.length > 0 ? data.dateValue[0] : '',
					endDate: window.sessionStorage.getItem('orderSearchTime') ? JSON.parse(window.sessionStorage.getItem('orderSearchTime'))[1] : data.dateValue.length > 0 ? data.dateValue[1] : '',
					orderNumber: data.orderNumber,
					keyword: data.keyword,
					buyerName: data.buyerName,
					buyerTel: data.buyerTel,
					pushstate: data.pushstate,
					paymentMode: +data.paymentMode,
					ordersource: +data.ordersource,
					finishFlag: +data.acceptMode,
					cancelstate: +data.cancelMode,
					liquidateflag: data.liquidateflag,
					customerCategoryId: data.customerCategoryId,
					lineId: data.lineId,
					address: data.address,
					productName: data.productName,
					customerName: data.customerName
				}
			} else {
				this.excelParams = {
					beginDate: window.sessionStorage.getItem('orderSearchTime') ? JSON.parse(window.sessionStorage.getItem('orderSearchTime'))[0] : this.dateValue.length > 0 ? this.dateValue[0] : '',
					endDate: window.sessionStorage.getItem('orderSearchTime') ? JSON.parse(window.sessionStorage.getItem('orderSearchTime'))[1] : this.dateValue.length > 0 ? this.dateValue[1] : '',
					orderNumber: this.orderNumber,
					keyword: this.keyword,
					buyerName: this.buyerName,
					buyerTel: this.buyerTel,
					pushstate: this.pushstate,
					paymentMode: +this.paymentMode,
					ordersource: +this.ordersource,
					finishFlag: +this.acceptMode,
					cancelstate: +this.cancelMode,
					liquidateflag: this.liquidateflag,
					customerCategoryId: this.customerCategoryId,
					lineId: this.lineId,
					address: this.address,
					productName: this.productName,
					customerName: this.customerName
				}
			}
			this.findShopList().then((data) => {
				if (data.length > 0) {
					if (tabParams === '') {
						this.sellerShopId = data[0].shopId
						this.tabParams.sellerShopId = data[0].shopId
						this.tabParams.organid = data[0].organid
						window.sessionStorage.setItem('tabInfo', JSON.stringify(this.tabParams))
					}
					this.shopOptions = data
					this.findCount()
					this.findOrderList()
				}
			})
		},
		modifySuc () {
			this.openPage()
			// this.findCount()
			// this.findOrderList()
		},
		shopChange () {
			let tabParams = JSON.parse(window.sessionStorage.getItem('tabInfo'))
			tabParams.sellerShopId = this.sellerShopId
			this.shopOptions.forEach(item => {
				if (this.sellerShopId === item.shopId) {
					tabParams.organid = item.organid
				}
			})
			window.sessionStorage.setItem('tabInfo', JSON.stringify(tabParams))
			this.findCount()
			this.findOrderList()
		},
		orderMenuSwitch (data) {
			let tabParams = JSON.parse(window.sessionStorage.getItem('tabInfo'))
			this.active = data.name
			this.orderStatus = data.orderStatus
			this.isSellerpull = data.isSellerpull
			tabParams.active = data.name
			tabParams.orderStatus = data.orderStatus
			tabParams.isSellerpull = data.isSellerpull
			window.sessionStorage.setItem('tabInfo', JSON.stringify(tabParams))
			if (data.name === '已取消') {
				this.isCancel = true
			} else {
				this.isCancel = false
			}
			this.findCount()
			// this.$refs.searchRef.clearInput()
			this.$refs.searchRef.search()
		},
		sortList (value) {
			this.orderSort = value
			this.findOrderList()
		},
		handleSizeChange (value) {
			this.size = value
			this.page = 1
			this.findOrderList()
		},
		handlePageChange (value) {
			this.page = value
			this.findOrderList()
		},
		handleSearch (data) {
			this.dateValue = data.dateValue
			this.buyerTel = data.buyerTel
			this.orderNumber = data.orderNumber
			this.keyword = data.keyword
			this.paymentMode = data.paymentMode
			this.ordersource = data.ordersource
			this.buyerName = data.buyerName
			this.acceptMode = data.acceptMode
			this.cancelMode = data.cancelMode
			this.pushstate = data.pushstate
			this.liquidateflag = data.liquidateflag
			this.customerCategoryId = data.customerCategoryId
			this.lineId = data.lineId
			this.address = data.address
			this.productName = data.productName
			this.customerName = data.customerName
			this.orderSort = ''
			this.page = 1
			this.dateType = data.dateType
			this.excelParams = {
				beginDate: window.sessionStorage.getItem('orderSearchTime') ? JSON.parse(window.sessionStorage.getItem('orderSearchTime'))[0] : data.dateValue.length > 0 ? data.dateValue[0] : '',
				endDate: window.sessionStorage.getItem('orderSearchTime') ? JSON.parse(window.sessionStorage.getItem('orderSearchTime'))[1] : data.dateValue.length > 0 ? data.dateValue[1] : '',
				orderNumber: data.orderNumber,
				keyword: data.keyword,
				buyerName: data.buyerName,
				buyerTel: data.buyerTel,
				pushstate: data.pushstate,
				paymentMode: +data.paymentMode,
				ordersource: +data.ordersource,
				finishFlag: +data.acceptMode,
				cancelstate: +data.cancelMode,
				liquidateflag: data.liquidateflag,
				customerCategoryId: data.customerCategoryId,
				lineId: data.lineId,
				address: data.address,
				productName: data.productName,
				customerName: data.customerName
			}
			this.saveSelect()
			this.findOrderList()
			this.findCount()
		},
		// 导出
		exportExcel () {
			const req = new XMLHttpRequest()
			let _this = this
			req.open('POST', `${this.$fxBaseApi.newExportUrl}/orderList/exportExcel`, true)
			req.responseType = 'blob'
			req.setRequestHeader('Content-Type', 'application/json')
			req.setRequestHeader('shiroSession', window.sessionStorage.getItem('shiroSession'))
			req.setRequestHeader('pname', 'bc2ff5388144d30e137b28acafd39795')
			req.onload = function () {
				const data = req.response
				const blob = new Blob([data])
				const blobUrl = window.URL.createObjectURL(blob)
				_this.download(blobUrl)
			}
			this.excelParams.ifBuyer = false
			this.excelParams.isCancel = this.isCancel
			this.excelParams.isSellerpull = this.isSellerpull
			this.excelParams.sellerShopId = this.sellerShopId
			if (this.orderStatus !== 8) {
				this.excelParams.orderStatus = this.orderStatus
			}
			req.send(JSON.stringify(this.excelParams))
		},
		download (blobUrl, num) {
			const a = document.createElement('a')
			a.style.display = 'none'
			var date = new Date()
			var year = date.getFullYear()
			var month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
			var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
			var hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
			var min = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
			let name = this.active === '全部订单' ? '全部 - 单据详情(' + year + month + day + hour + min + ').xls' : this.active + ' - 单据详情(' + year + month + day + hour + min + ').xls'
			a.download = name
			a.href = blobUrl
			a.click()
		},
		getSystemSet () {
			return new Promise((resolve, reject) => {
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
				}).then(res => {
					this.needauditingflag = res.needauditingflag
					this.canundeliveredunpaysendflag = res.canundeliveredunpaysendflag
					this.needFinancialAuditingFlag = res.needFinancialAuditingFlag
					resolve(res)
				}).catch(err => {
					this.$message.error(err.msg)
				})
			})
		},
		findShopList () {
			return new Promise((resolve, reject) => {
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/findshoplist`
				}).then(res => {
					if (res.result) {
						this.clearing = res.data.clearing
						resolve(res.data.shop)
					} else {
						this.$message.error(res.msg)
					}
				}).catch(err => {
					this.$message.error(err.msg)
				})
			})
		},
		findOrderList () {
			this.tableData = []
			let params = {
				beginDate: this.dateType ? '' : (window.sessionStorage.getItem('orderSearchTime') ? JSON.parse(window.sessionStorage.getItem('orderSearchTime'))[0] : this.dateValue.length > 0 ? this.dateValue[0] : ''),
				endDate: this.dateType ? '' : (window.sessionStorage.getItem('orderSearchTime') ? JSON.parse(window.sessionStorage.getItem('orderSearchTime'))[1] : this.dateValue.length > 0 ? this.dateValue[1] : ''),
				wantArrivalBeginDate: this.dateType ? (window.sessionStorage.getItem('orderSearchTime') ? JSON.parse(window.sessionStorage.getItem('orderSearchTime'))[0] : this.dateValue.length > 0 ? this.dateValue[0] : '') : '',
				wantArrivalEndDate: this.dateType ? (window.sessionStorage.getItem('orderSearchTime') ? JSON.parse(window.sessionStorage.getItem('orderSearchTime'))[1] : this.dateValue.length > 0 ? this.dateValue[1] : '') : '',
				orderNumber: this.orderNumber,
				// keyword: this.keyword,
				buyerName: this.buyerName,
				buyerTel: this.buyerTel,
				// pushstate: this.pushstate,
				paymentMode: +this.paymentMode,
				ordersource: +this.ordersource,
				// finishFlag: +this.acceptMode,
				cancelstate: +this.cancelMode,
				isCancel: this.isCancel,
				liquidateflag: this.liquidateflag,
				page: this.page,
				size: this.size,
				isSellerpull: this.isSellerpull,
				sellerShopId: this.sellerShopId,
				customerCategoryId: this.customerCategoryId,
				lineId: this.lineId,
				address: this.address,
				productName: this.productName,
				customerName: this.customerName,
				orderby: this.orderSort !== '' ? 'orderstatus' : '',
				orderSort: this.orderSort
			}
			if (this.orderStatus !== 8) {
				params.orderStatus = this.orderStatus
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/findlistnew`,
				data: params
			}).then(res => {
				this.totalCount = +res.recordCount
				this.clddock = res.clddock
				this.backorderdock = res.backorderdock
				if (res.recordList !== null) {
					res.recordList.forEach(item => {
						item.checked = false
						item.childShow = false
						item.bold = false
						if (this.orderNumber && item.ordernumber.indexOf(this.orderNumber) !== -1) {
							item.bold = true
						}
						item.child.forEach(e => {
							e.bold = false
							if (this.orderNumber && e.ordernumber.indexOf(this.orderNumber) !== -1) {
								e.bold = true
							}
						})
						item.finalprice = this.$fxUtils.toFixedSHW(item.finalprice, 2)
						if (item.child.length !== 0) {
							item.child.forEach(e => {
								e.totalmoney = this.$fxUtils.toFixedSHW(e.totalmoney, 2)
							})
						}
						if (item.iscancel === 1) {
							item.billState = '已取消'
						} else {
							switch (item.billState) {
							case '0':
								item.billState = '待付款'
								break
							case '1':
								item.billState = '待接单'
								break
							case '2':
								item.billState = item.sellpullstate === 1 ? '备货中' : '待发货'
								break
							case '3':
								item.billState = '待收货'
								break
							case '4':
								item.billState = '已完成'
								break
							case '5':
								item.billState = '已取消'
								break
							case '6':
								item.billState = '财务审核'
								break
							}
						}
						if (item.paymentmode.length === 1) {
							switch (item.paymentmode) {
							case '0':
								item.paymentmode = '线下'
								break
							case '1':
								item.paymentmode = '商龙钱包'
								break
							case '2':
								item.paymentmode = '微信支付'
								break
							case '3':
								item.paymentmode = '支付宝'
								break
							case '4':
								item.paymentmode = '预付货款'
								break
							}
						} else if (item.paymentmode.length > 1) {
							if (item.paymentmode.includes('3')) {
								item.paymentmode = '预付货款、支付宝'
							} else {
								item.paymentmode = '预付货款、商龙钱包'
							}
						}
					})
				}
				this.tableData = res.recordList
			})
		},
		findCount () {
			let params
			if (this.orderStatus === 8 || this.orderStatus === 4 || this.orderStatus === 5) {
				params = {
					ifBuyer: false,
					sellerShopId: this.sellerShopId,
					isSellerpull: this.isSellerpull,
					beginDate: window.sessionStorage.getItem('orderSearchTime') ? JSON.parse(window.sessionStorage.getItem('orderSearchTime'))[0] : this.dateValue[0],
					endDate: window.sessionStorage.getItem('orderSearchTime') ? JSON.parse(window.sessionStorage.getItem('orderSearchTime'))[1] : this.dateValue[1]
				}
			} else {
				params = {
					ifBuyer: false,
					sellerShopId: this.sellerShopId,
					isSellerpull: this.isSellerpull,
					orderStatus: this.orderStatus,
					beginDate: window.sessionStorage.getItem('orderSearchTime') ? JSON.parse(window.sessionStorage.getItem('orderSearchTime'))[0] : this.dateValue[0],
					endDate: window.sessionStorage.getItem('orderSearchTime') ? JSON.parse(window.sessionStorage.getItem('orderSearchTime'))[1] : this.dateValue[1]
				}
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/findcount`,
				data: params
			}).then(res => {
				if (res.result) {
					res.data.forEach(item => {
						this.orderMenu.forEach(menuItem => {
							if (item.billState === menuItem.billState) {
								menuItem.count = item.count
							}
							if (item.billState === 5) {
								this.totalOrderCount = item.count
							}
							if (item.billState === 6) {
								this.financialOrderCount = item.count
							}
						})
					})
					if (!this.financialOrderCount && !this.needFinancialAuditingFlag) {
						this.orderMenu = this.orderMenu.filter(item => item.name !== '财务审核')
					}
				}
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.order-body {
	width :100%;
	height:100%;
	min-width :1100px;
	overflow:auto;
	background-color :#ffffff;
	display: flex;
	flex-direction: column;
	.shop-position {
		display flex
		align-items: center
		height: 50px
		min-height: 50px
		font-size: 14px
		border-bottom: 1px solid #dce1fe
		img {
			display inline-block
			width: 20px
			height: 22px
			margin-right: 10px
		}
	}
	.order-menu {
		height: 50px
		display flex
		position relative
		border-bottom: 1px solid #dce1fe
		li {
			height: 100%
			line-height: 49px
			margin-right: 60px
			font-size: 15px
			// font-weight: 700
			box-sizing:border-box
			cursor: pointer
			position: relative
			color: #595959
			&.active {
				color: var(--fx-primary-color)
				border-bottom: 2px solid var(--fx-primary-color)
			}
			span {
				position: absolute;
				width: 18px;
				height: 18px;
				line-height: 18px;
				border-radius: 50%;
				font-size: 11px;
				top: 5px;
				right: -18px;
				text-align: center;
				background-color: #EC4141;
				color: #fff;
				&.big-num {
					width: 28px;
					border-radius: 40px;
					right: -28px;
				}
			}
		}
		div {
			height: 100%
			line-height: 49px
			font-size: 14px
			font-weight: 700
			box-sizing:border-box
			position absolute;
			top: 0;
			right: 50px;
		}
	}
}
</style>
<style lang="stylus">
.order-body {
	.el-dialog {
		border-radius: 4px
	}
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
	.el-dialog__body {
		padding-top: 10px
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
</style>
